//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { LocationAddressDisplayItem } from './LocationAddressDisplayItem';
import { EventLocationNameDisplayItem } from './EventLocationNameDisplayItem';
import { CallInitiationType } from './Enums';

export class EventLocationDisplayItem extends EventLocationNameDisplayItem {
    Active: boolean = false;
    Address: LocationAddressDisplayItem | null = null;
    URL: string | null = null;
    ResolvedAddress: string | null = null;
    SharedLocation: boolean = false;
    EventCount: number | null = null;

    constructor(initializer?: Partial<EventLocationDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "EventLocationDisplayItem";
}
